import { all, takeLatest, put } from 'redux-saga/effects';

import {
    CREATE_CALENDAR,
    GET_ALL_CALENDARS,
    GET_CALENDAR,
    GET_PLAYER_CALENDAR,
    UPDATE_CALENDAR,
    DELETE_CALENDAR,
    DUPLICATE_CALENDAR,
    FILTER_CALENDAR,
    UPDATE_DOOR_DRAG_DROP
} from './constants';
import {
    requestCalendarCreation,
    requestAllCalendars,
    requestCalendar,
    requestUpdateCalendar,
    requestPlayerCalendar,
    requestDeleteCalendar,
    requestCalendarDuplication,
    requestCalendarFilter,
    requestDoorDrop
} from './api';
import {
    createCalendarSuccess,
    getAllCalendarsSuccess,
    getCalendarSuccess,
    updateCalendarSuccess,
    getPlayerCalendarSuccess,
    deleteCalendarSuccess,
    updateCalendarFilterSuccess,
    updateDoorDragDropSuccess
} from './actions';
import { getHatchesSuccess } from './hatch/actions';

import { getPrizesSuccess } from './navigation/prizes/actions';

import watchSettings from '../../data/calendar/settings/sagas';
import watchQuestions from './questions/sagas';
import watchRules from './navigation/rules/sagas';
import watchWinners from './navigation/winners/sagas';
import watchCalendarPlayers from './players/sagas';
import watchHatchAnswers from './questions/answers/sagas';


/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{calendar, type}>>}
 */
function* createCalendar( actionObj ) {
    const calendar = yield requestCalendarCreation( actionObj.title, actionObj.lang );
    if ( calendar ) {
        yield put( createCalendarSuccess( calendar ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{calendar, type}>>}
 */
function* duplicateCalendar( actionObj ) {
    const calendar = yield requestCalendarDuplication( actionObj.title, actionObj.lang, actionObj.calendarID );
    if ( calendar ) {
        yield put( createCalendarSuccess( calendar ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{calendars, type}>>}
 */
function* updateTheCalendarFilter( actionObj ) {
    const calendar = yield requestCalendarFilter( actionObj.typeQuiz, actionObj.page, actionObj.tenant, actionObj.search, actionObj.filter );
    if ( calendar ) {
        yield put( updateCalendarFilterSuccess( calendar ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{calendars, type}>>}
 */
function* getAllCalendars( actionObj ) {
    const calendars = yield requestAllCalendars( actionObj.page, actionObj.tenant );
    if ( calendars ) {
        yield put( getAllCalendarsSuccess( calendars ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{prizes, type}>|PutEffect<{hatches, type}>|PutEffect<{calendar, type}>>}
 */
function* getCalendar( actionObj ) {
    const calendar = yield requestCalendar( actionObj.id );
    if ( calendar ) {
        yield put( getCalendarSuccess( calendar ) );
        yield put( getHatchesSuccess( calendar.hatches ) );
        yield put( getPrizesSuccess( calendar.prizes ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{type, playerCalendar}>>}
 */
function* getPlayerCalendar( actionObj ) {
    const playerCalendar = yield requestPlayerCalendar( actionObj.id, actionObj.key );
    if ( playerCalendar ) {
        yield put( getPlayerCalendarSuccess( playerCalendar ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{calendar, type}>>}
 */
function* updateCalendar( actionObj ) {
    const calendar = yield requestUpdateCalendar( actionObj.id, actionObj.value );
    if ( calendar ) {
        yield put( updateCalendarSuccess( calendar ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{data, id, type}>>}
 */
function* deleteCalendar( actionObj ) {
    const calendar = yield requestDeleteCalendar( actionObj.id );
    if ( calendar ) {
        yield put( deleteCalendarSuccess( calendar.data, actionObj.id ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {Generator<SimpleEffect<"PUT", PutEffectDescriptor<{calendar: *, type: string}>>|SimpleEffect<"PUT", PutEffectDescriptor<{hatches: *, type: string}>>|*, void, *>}
 */
function* dragDropDoor(actionObj) {
    const newQuestions = yield requestDoorDrop(actionObj.calendarID, actionObj.result);
    if (newQuestions) {
        yield put( getHatchesSuccess( newQuestions.hatches ) );
        yield put(updateDoorDragDropSuccess(newQuestions));
    }
}

/**
 *
 * @returns {Generator<SimpleEffect<"FORK", ForkEffectDescriptor<never>>, void, *>}
 */
function* watchCalendar() {
    yield takeLatest( CREATE_CALENDAR, createCalendar );
    yield takeLatest( GET_ALL_CALENDARS, getAllCalendars );
    yield takeLatest( GET_CALENDAR, getCalendar );
    yield takeLatest( UPDATE_CALENDAR, updateCalendar );
    yield takeLatest( GET_PLAYER_CALENDAR, getPlayerCalendar );
    yield takeLatest( DELETE_CALENDAR, deleteCalendar );
    yield takeLatest( DUPLICATE_CALENDAR, duplicateCalendar );
    yield takeLatest( FILTER_CALENDAR, updateTheCalendarFilter );
    yield takeLatest( UPDATE_DOOR_DRAG_DROP, dragDropDoor);
}

function* calendarSaga() {
    yield all( [
        watchCalendar(),
        watchSettings(),
        watchQuestions(),
        watchRules(),
        watchWinners(),
        watchCalendarPlayers(),
        watchHatchAnswers()
    ] );
}

export default calendarSaga;